// import React, { useState } from 'react';
// import { Link } from 'react-router-dom';
// import './styles/Navbar.css';
// import logo from '../components/images/logo.png';

// const Navbar = () => {
//   const [isOpen, setIsOpen] = useState(false);

//   // Toggle the menu visibility
//   const toggleMenu = () => {
//     setIsOpen(!isOpen);
//   };

//   // Close the menu when a link is clicked
//   const closeMenu = () => {
//     setIsOpen(false);
//   };

//   return (
//     <nav className="navbar">
//       <div className="logo">
//         <Link to="/" onClick={closeMenu}>
//           <img src={logo} alt="Logo" />
//         </Link>
//       </div>
//       <div className={`nav-links ${isOpen ? 'open' : ''}`}>
//         <ul>
//           <li><Link to="/" onClick={closeMenu}>Home</Link></li>
//           <li><Link to="/pricing" onClick={closeMenu}>Pricing</Link></li>
//           <li><Link to="/gig" onClick={closeMenu}>Gig Description</Link></li>
//           <li><Link to="/videos" onClick={closeMenu}>Previous Work</Link></li>
//           <li><Link to="/client" onClick={closeMenu}>Client Review</Link></li>
//           <li><Link to="/contact" onClick={closeMenu}>Contact Me</Link></li>
//         </ul>
//       </div>
//       <div className="hamburger" onClick={toggleMenu}>
//         {/* Conditional rendering for hamburger vs cross */}
//         {isOpen ? (
//           <span className="close-icon">✖</span> // Cross when menu is open
//         ) : (
//           <>
//             <span className="bar"></span> {/* Hamburger top bar */}
//             <span className="bar"></span> {/* Hamburger middle bar */}
//             <span className="bar"></span> {/* Hamburger bottom bar */}
//           </>
//         )}
//       </div>
//     </nav>
//   );
// };

// export default Navbar;

import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faHome, faDollarSign, faBriefcase, faVideo, faEnvelope, faCommentDots
} from '@fortawesome/free-solid-svg-icons';
import { faInstagram, faWhatsapp, faFacebook, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import './styles/Navbar.css';
import logo from '../components/images/logo.png';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  // Toggle the menu visibility
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  // Close the menu when a link is clicked
  const closeMenu = () => {
    setIsOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="logo">
        <Link to="/" onClick={closeMenu}>
          <img src={logo} alt="Logo" />
        </Link>
      </div>
      <div className={`nav-links ${isOpen ? 'open' : ''}`}>
        <ul>
          <li><Link to="/" onClick={closeMenu}><FontAwesomeIcon icon={faHome}  className='icon'/> Home</Link></li>
          <li><Link to="/pricing" onClick={closeMenu}><FontAwesomeIcon icon={faDollarSign}  className='icon'/> Pricing</Link></li>
          <li><Link to="/gig" onClick={closeMenu}><FontAwesomeIcon icon={faBriefcase}  className='icon'/> Gig Description</Link></li>
          <li><Link to="/videos" onClick={closeMenu}><FontAwesomeIcon icon={faVideo}  className='icon'/> Previous Work</Link></li>
          <li><Link to="/client" onClick={closeMenu}><FontAwesomeIcon icon={faCommentDots}  className='icon' /> Client Review</Link></li>
          <li><Link to="/contact" onClick={closeMenu}><FontAwesomeIcon icon={faEnvelope}  className='icon'/> Contact Me</Link></li>
           <li><Link to="/contact" className="global-button-mobile">
                    Hire Me 
                  </Link></li>
        </ul>
      </div>
      
      <div className="social-icons">
        <a href="https://www.instagram.com/audioeditingguy" target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faInstagram} className="social-icon" />
        </a>
        <a href="https://wa.me/+923028335819" target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faWhatsapp} className="social-icon" />
        </a>
        <a href="https://www.facebook.com/audioeditingguy/" target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faFacebook} className="social-icon" />
        </a>
        <a href="https://www.linkedin.com/in/audioeditingguy/" target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faLinkedin} className="social-icon" />
        </a>
      </div>
      
      <div className="hamburger" onClick={toggleMenu}>
        {isOpen ? (
          <span className="close-icon">✖</span>
        ) : (
          <>
            <span className="bar"></span>
            <span className="bar"></span>
            <span className="bar"></span>
          </>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
